import User from "@/model/user";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import UserApi from "@/api/userApi";
import PaginateModel from "@/model/paginate";

@Module({ namespaced: true })
export default class UserModule extends VuexModule {
  users: User[] = [];
  representativeCustomers: User[] = [];
  paginate: PaginateModel;
  @Mutation
  setUsers(users: User[]): void {
    this.users = users;
  }
  @Mutation
  setRepresentativeCustomers(data: User[]): void {
    this.representativeCustomers = data;
  }
  @Mutation
  setPaginate(paginate: PaginateModel): void {
    this.paginate = paginate;
  }
  @Action({ rawError: true })
  async fetchUserList(query: any): Promise<void> {
    const { list, paginate } = await UserApi.getAllUsers(query);
    this.context.commit("setUsers", list);
    this.context.commit("setPaginate", paginate);
  }

  @Action({ rawError: true })
  async fetchRepresentativeCustomersList(query: any): Promise<void> {
    const { list, paginate } = await UserApi.getRepresentativeCustomersList(
      query
    );
    this.context.commit("setRepresentativeCustomers", list);
    this.context.commit("setPaginate", paginate);
  }

  get getUsers(): User[] {
    return this.users;
  }
  get getRepresentativeCustomers(): User[] {
    return this.representativeCustomers;
  }
  get getPaginate(): PaginateModel {
    return this.paginate;
  }
}
